import type { ReactNode } from "react";

interface Props {
  kicker: string;
  title: string;
  desc?: string;
  action?: ReactNode;
  light?: boolean;
}

export default function SectionTitle({ kicker, title, desc, action, light }: Props) {
  return (
    <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <p className={`flex items-center gap-2 text-sm font-semibold ${light ? "text-accent-300" : "text-primary-600"}`}>
          <span className={`h-px w-6 ${light ? "bg-accent-300" : "bg-primary-500"}`}></span>
          {kicker}
        </p>
        <h2 className={`mt-1 font-heading text-2xl font-bold md:text-3xl ${light ? "text-background-50" : "text-foreground-950"}`}>
          {title}
        </h2>
        {desc && <p className={`mt-2 max-w-2xl text-sm ${light ? "text-background-300/90" : "text-foreground-600"}`}>{desc}</p>}
      </div>
      {action}
    </div>
  );
}